import React from 'react';
import { Row, Col, Tooltip } from 'antd';
import {verifIsLogged,setDisconnectMachineId, getMachineId, getPays, setLanguage, getLanguage} from "../util/Toolbox";
import { withTranslation } from 'react-i18next';

import {VerticalAlignBottomOutlined } from '@ant-design/icons';

import './css/home.css';
import './css/navBar.css';

import analyse_picto_bleu         from './assets/home/analyse_picto-bleu.png';
import calcul_picto               from './assets/home/calcul_picto.png';
import ordonnance_picto           from './assets/home/ordonnance_picto.png';
import admin_picto                from './assets/home/picto_admin.png';
import spintouch_picto            from './assets/home/spintouch_picto.png'; 
import picto_home                 from './assets/home/picto_home.png';
import image_footer               from './assets/home/image_footer.png';
import home_enfant                from './assets/home/home_enfant.png';
import axios                      from '../util/Api'
import ElectronWaterLinkService   from '../services/ElectronWaterLinkService'

// URL de téléchargement de l'application Electron
const ELECTRON_DOWNLOAD_URL = 'https://spintouch.s3.fr-par.scw.cloud/DesjoyauxSetup.exe';

class Home extends React.Component {

  state = {
    conseil_LIST : [],
    IsAdmin : false,
    languages_LIST : [],
    language : getLanguage(),
    isElectron: false,
    // États pour la mise à jour
    updateStatus: 'checking', // 'checking' | 'available' | 'current' | 'error'
    backendVersion: null,
    electronVersion: null,
  }

  async componentDidMount() {

    verifIsLogged();

    let languages_LIST = getPays();

    this.setState({languages_LIST : languages_LIST});

    let guid_compte = getMachineId();

    this.state.guid_compte = guid_compte;

    const {i18n } = this.props;
    let newLang = getLanguage();
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    this.setState({language : newLang});

    // Détection de l'environnement Electron pour contrôler l'affichage Spintouch
    let isElectron = ElectronWaterLinkService.isElectronApp();
    console.log('isElectron:', isElectron);
    this.state.isElectron = isElectron;
    this.setState({ isElectron });

    // Vérifier les mises à jour si dans Electron
    if (isElectron) {
      this.checkForUpdates();
    }

    // On regarde accès admin pour cet utilisateur
    axios.get(`analyse/${this.state.guid_compte}/loadProfile`,
    ).then(({data}) => {

      if(data.success == 'success'){
        if(data.user.IsAccesBack == 1){
          //console.log("admin");
          this.setState({IsAdmin : true})
        }else{
          //console.log("simple");
          this.setState({IsAdmin : false})
        }

      }

    }).catch(function (error) {
      console.log("Error****:", error.message);
      this.setState({isLoading : false})
    });

  }

  async checkForUpdates() {

    console.log('checkForUpdates called, isElectron:', this.state.isElectron);
    if (!this.state.isElectron) {
      console.log('Not in Electron, skipping update check');
      return;
    }

    try {
      // Récupérer la version Electron
      console.log('window.electronAPI:', window.electronAPI);
      console.log('window.electronAPI keys:', Object.keys(window.electronAPI || {}));
      let electronVersion = await window.electronAPI.version();

      console.log('electronVersion', electronVersion);

     /// electronVersion = '1.1.0';

      
      if (!electronVersion) {
        console.warn('Version Electron non disponible');
        this.setState({
          updateStatus: 'error',
          electronVersion: null
        });
        return;
      }
        

      console.log('Calling API: analyse/version');
      // Récupérer la version de l'API backend
      const response = await axios.get('analyse/version');

      console.log('API response:', response.data);

      if (response.data.success === 'success' && response.data.version) {
        const backendVersion = response.data.version.NumeroVersion;

        // Normaliser les versions pour comparaison (enlever "v" si présent)
        const normalizeVersion = (v) => v.replace(/^v/, '').trim();
        const updateAvailable = normalizeVersion(backendVersion) !== normalizeVersion(electronVersion);

        this.setState({
          updateStatus: updateAvailable ? 'available' : 'current',
          backendVersion: backendVersion,
          electronVersion: electronVersion
        });
      } else {
        this.setState({ updateStatus: 'error' });
      }
    } catch (error) {
      console.error('Erreur lors de la vérification des mises à jour:', error);
      this.setState({ updateStatus: 'error' });
    }
  }

    // Fonction pour changer la langue
  handleChangeLanguage = (event) => {
      const newLang = event.target.value;
      // Définir la langue  
      const {i18n } = this.props;
      console.log(newLang);
      i18n.changeLanguage(newLang);
      setLanguage(newLang);
      this.setState({language : newLang});
  };

  onClickDisconnect = () => {
    setDisconnectMachineId();
  }

  getUpdateText() {
    const { t } = this.props;
    const { updateStatus } = this.state;

    switch (updateStatus) {
      case 'checking':
        return t('menu_update_checking');
      case 'available':
        return t('menu_update_available');
      case 'current':
        return t('menu_update_current');
      case 'error':
        return t('menu_update_error');
      default:
        return t('menu_update_checking');
    }
  }

  renderUpdateIndicator() {
    const { updateStatus } = this.state;

    const indicatorStyles = {
      checking: { color: '#888' },
      available: { color: '#ff9800' }, // Orange
      current: { color: '#4caf50' },   // Vert
      error: { color: '#f44336' }      // Rouge
    };

    const style = indicatorStyles[updateStatus] || indicatorStyles.checking;

    return (
      <span
        style={{
          ...style,
          fontSize: '22px',
          marginRight: '8px',
          verticalAlign: 'middle'
        }}
      >
        <VerticalAlignBottomOutlined/>
      </span>
    );
  }

  render() {

    const { t, i18n } = this.props; // Récupérer la traduction et le changement de langue

      return (

        <div>

          <div className = "wrapper_home">

            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

              <nav>
                  <ul>
                      <li><a href = "/"><img loading="lazy" src={picto_home} width ="180px"/></a></li>
                      <li><a style = {{marginTop : 10}} href="/forms">{t('menu_analyse')}</a></li>
                      <li><a href="/simulateur">{t('menu_calcul_volume')}</a></li>
                      <li><a href="/historique">{t('menu_historique')}</a></li>
                      <li> <span onClick={setDisconnectMachineId}> <a href="#">{t('menu_login') } </a> </span>  </li>

                      <li>
                        <select
                          id="language-select"
                          value={this.state.language}
                          disabled = {false}
                          onChange={this.handleChangeLanguage}
                          style={{ padding: '5px', fontSize: '16px', cursor: 'pointer' }}
                        >
                          {this.state.languages_LIST.map((lang) => (
                            <option key={lang.code} value={lang.code}>
                              {lang.flag} {lang.label}
                            </option>
                          ))}
                        </select>
                      </li>

                      {/* Item de menu Mise à jour - Visible uniquement dans Electron */}
                      {this.state.isElectron && (
                        <li>
                          {this.state.updateStatus === 'available' ? (
                            <Tooltip title={t('menu_update_download')}> 
                            <a
                              href={ELECTRON_DOWNLOAD_URL}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{fontSize : 11,  display: 'inline-flex', alignItems: 'center' }}
                            >
                              {this.renderUpdateIndicator()}
                              <span>{this.getUpdateText()}</span>
                            </a>
                            </Tooltip>
                          ) : (
                            <Tooltip title={t('menu_update_app_current')}> 
                            <span
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                cursor: 'default',
                                color: '#2B4570',
                                fontSize : 16
                              }}
                            >
                              {this.renderUpdateIndicator()}
                             
                              <span>{this.getUpdateText()}</span>
                            </span>
                            </Tooltip>
                          )}
                        </li>
                      )}

                  </ul>
              </nav>

              <div className = "containersHome">
                <div className='containerHero'>
                  <img className='imageHero'  loading="lazy" src={home_enfant}  width ="100%"/>
                  <div className='textHero'>{t('hero_title1')}</div>
                  <div className='textHero2'>{t('hero_title2')}</div>
                </div>

                <Row style = {{ marginTop:60, textAlign : 'center'}} gutter={[30, 30]}>

                  <Col xs={12} sm={12} md={8} lg={8} xl={8} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationRECTANGULAIRE}>
                    <div  className= "homeMenuCell">
                      <a href = "/forms"><img loading="lazy"  src={analyse_picto_bleu} width ="150px"  height ="150px" />
                        <p className= "button_home">{t('home_analyse')}</p>
                      </a>
                     
                    </div>
                  </Col>

                  <Col  xs={12} sm={12} md={8} lg={8} xl={8} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationOVALE}>
                    <div className= "homeMenuCell">
                      <a href = "/simulateur"><img  loading="lazy" src={calcul_picto}  width ="180px"  height ="180px" />
                        <p className= "button_home">{t('home_calcule')}</p>
                      </a>
                     
                    </div>
                  </Col>

                  <Col  xs={12} sm={12} md={8} lg={8} xl={8} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationRONDE}>
                    <div className= "homeMenuCell">
                      <a href = "/historique"><img loading="lazy"  src={ordonnance_picto}   width ="180px"  height ="180px" />
                      <p className= "button_home">{t('home_enregistre')}</p>
                      </a>
                    </div>
                  </Col>

                  { this.state.IsAdmin == true &&
                    <Col  xs={12} sm={12} md={8} lg={8} xl={8} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationRONDE}>
                      <div className= "homeMenuCell">
                        <a href = "/administration"><img loading="lazy"  src={admin_picto}   width ="180px"  height ="180px" />
                        <p className= "button_home">{t('home_admin')}</p>
                        </a>
                      </div>
                    </Col>
                  }

                  {  this.state.isElectron == true &&
                    <Col  xs={12} sm={12} md={8} lg={8} xl={8} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationRONDE}>
                      <div className= "homeMenuCell">
                          <a href = "/spintouch"><img loading="lazy"  src={spintouch_picto}   width ="180px"  height ="180px" />
                        <p className= "button_home">{t('home_spintouch')}</p>
                        </a>
                      </div>
                    </Col>
                  }
                 
                </Row>
              </div>

             

          </div>

        </div>

      )

    };
}


export default withTranslation() (Home);


